module.exports = __webpack_public_path__ + "images/icon-stopwatch.fa9a9f.svg";